export default __webpack_public_path__ + "static/media/view.360c9a8f.svg";